import styled from '@emotion/styled';

/*
 * TODO:
 * 100px - large - gradient 66px
 * 92px - middle - gradient 55px
 * 84px - small - gradient 47px;
 */
export const BottomBar = styled.div`
  box-sizing: border-box;
  z-index: 99;
  position: fixed;
  left: 0;
  bottom: 0px;
  width: 100%;
  padding-top: 56px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 56px, #ffffff 100%);
`;
